import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function MemberPage() {
  const { ui } = useOrignalUi();
  const { memberId } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    api(`/api/members/${memberId}`).then(setData).catch(() => {});
  }, [memberId]);
  if (!data) return <main className="og-page" data-testid="page-member"><p>{ui.app.loading}</p></main>;
  const m = data.member;
  return (
    <main className="og-page" data-testid="page-member">
      <h1>{m.display_name}</h1>
      <p className="og-lead">{m.kind === "associated" ? ui.group.associated : m.trip_role === "organizer" ? ui.group.organizer : m.role === "admin" ? ui.group.admin : ui.group.hunter} · {m.status === "to_confirm" ? ui.group.toConfirm : ui.group.active}</p>
      <Link className="og-btn" to="/mes-affaires">{ui.nav.myStuff}</Link>
      <div className="og-stats">
        <div className="og-stat"><strong>{data.contributions.photos}</strong><span>{ui.nav.photos}</span></div>
        <div className="og-stat"><strong>{data.contributions.tasks}</strong><span>{ui.nav.tasks}</span></div>
        <div className="og-stat"><strong>{data.contributions.expenses}</strong><span>{ui.nav.expenses}</span></div>
      </div>
    </main>
  );
}
